<template>
  <div class="container">
    <div class="backBtnBox">
      <a-button type="primary" @click="backTap"> 返回 </a-button>
    </div>
    <div class="memberDetailMain clearfix">
      <div class="memberDetailLeft">
        <a-avatar
          :src="
            renderData.member && renderData.member.userAvatarUrl
              ? renderData.member.userAvatarUrl
              : 'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png'
          "
          :size="100"
          style="background: #c4c4c4"
        />
        <p style="margin-top: 20px">
          名称：{{
            renderData.member && renderData.member.memberName
              ? renderData.member.memberName
              : '暂无'
          }}
        </p>
        <p style="margin-top: 20px">
          微信昵称：{{
            renderData.member && renderData.member.userNickName
              ? renderData.member.userNickName
              : '暂无'
          }}
        </p>
        <p>
          手机号：{{
            renderData.member && renderData.member.mobileNumber
              ? renderData.member.mobileNumber
              : '暂无'
          }}
        </p>
        <p>
          unionid：{{
            renderData.member && renderData.member.unionId
              ? renderData.member.unionId
              : '暂无'
          }}
        </p>
        <p>
          性别：{{
            renderData.member && renderData.member.userGender!=null
            ? (renderData.member.userGender == 0 ? "男" : "女"):
            "未知"
          }}
        </p>
        <p>
          客户类型：{{
          renderData.member && renderData.member.memberType!=null
          ? this.getMemberTypeName(renderData.member.memberType)
              : '暂无'
          }}
        </p>
        <p v-if="renderData.member && renderData.member.memberType==1">
          机构名称：{{
            renderData.ctMmOrg && renderData.ctMmOrg.organizationName
              ? renderData.ctMmOrg.organizationName
              : '暂无'
          }}
        </p>
        <p>
          客户经理：{{
            renderData.member && renderData.member.customerManager
              ? renderData.member.customerManager
              : '暂无'
          }}
        </p>
        <p>
          地区：{{
            renderData.ctMmInfo && renderData.ctMmInfo.address
              ? renderData.ctMmInfo.address
              : '暂无'
          }}
        </p>
         <p>职业：{{
           renderData.ctMmInfo && renderData.ctMmInfo.careerDict
           ? renderData.ctMmInfo.careerDict
           : '暂无'
           }}</p>
         <p>
          收入区间：{{
            renderData.ctMmInfo && renderData.ctMmInfo.annualIncomeDict
           ? renderData.ctMmInfo.annualIncomeDict
              : '暂无'
          }}
        </p>
         <p>可投资基金产品的比例区间：：{{
           renderData.ctMmInfo && renderData.ctMmInfo.fundHoldingRateDict
           ? renderData.ctMmInfo.fundHoldingRateDict
           : '暂无'
           }}</p>
      </div>
      <div class="memberDetailRight">
        <div class="rightMain">
          <div class="rightBox">
            <div class="rightTop clearfix">
              <div class="topItem">
                <h4>会员等级</h4>
                <h3>
                  {{
                    renderData.member && renderData.member.memberGroupName
                      ? renderData.member.memberGroupName
                      : '暂无'
                  }}
                </h3>
              </div>
              <div class="topItem">
                <h4>注册时间</h4>
                <h3>
                  {{
                    renderData.member && renderData.member.createTime
                      ? renderData.member.createTime
                      : '暂无'
                  }}
                </h3>
              </div>
              <div class="topItem">
                <h4>会员卡到期时间</h4>
                <h3>
                  {{
                    renderData.member && renderData.member.memberEffectiveTime
                      ? renderData.member.memberEffectiveTime
                      : '暂无'
                  }}
                </h3>
              </div>
            </div>
            <div class="rightSub">
              <h3>历史信息</h3>
              <a-table
                ref="table"
                :scroll="{ x: true }"
                rowKey="id"
                :columns="columns"
                :dataSource="data"
                :pagination="ipagination"
                :loading="loading"
                @change="handleTableChange"
              >
              </a-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getDetailInfo, getDetailList } from '@/api/member.js';
import { filterObj } from '@/utils/util';
import {
  filterDictTextByCache,
} from '@/components/dict/JDictSelectUtil';
const columns = [
  {
    title: '订单号',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '等级名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
  },
  {
    title: '办卡类型',
    dataIndex: 'cardName',
    key: 'cardName',
    ellipsis: true,
  },
  {
    title: '支付金额',
    dataIndex: 'payment',
    key: 'payment',
    ellipsis: true,
    customRender: text => {
      if (text >= 0) {
        return text+'元';
      } else {
        return "--";
      }
    },
  },
  {
    title: '支付方式',
    dataIndex: 'paymentType',
    key: 'paymentType',
    ellipsis: true,
    customRender: text => {
      if (text == 0) {
        return '微信支付';
      } else {
        return "--";
      }
    },
  },
  {
    title: '支付时间',
    dataIndex: 'paymentTime',
    key: 'paymentTime',
    ellipsis: true,
  },
];

export default {
  inject: ['closeCurrent'],
  data() {
    return {
      id: this.$route.query.id,
      renderData: {
        ctMmOrg: {},
        member: {},
      },
      data: [],
      columns,
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
    };
  },
  created() {
    this.getMemberDetailInfo();
  },
  methods: {
    getMemberTypeName(memberType){
      console.log("222222222222222222222222222222")
      console.log(memberType==0)
      console.log("00000000000000000000000000000000000000")
      return memberType==0?"个人会员":"机构会员"
    },
    getMemberDetailInfo() {
      let params = {
        id: this.id,
      };
      this.loading = true;
      getDetailInfo(params).then((res) => {
        this.loading = false;
        if (res.success) {
          this.renderData = res.result;
          console.log("11111111111111111111111111")
      console.log(res.result.member.memberType==0)
      console.log("00000000000000000000000000000000000000")
          this.loadData(1);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.loadData();
    },
    loadData(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      let params = this.getQueryParams();
      params.unionId = this.renderData.member.unionId;
      this.loading = true;
      getDetailList(params).then((res) => {
        this.loading = false;
        if (res.success) {
          this.data =
            res.result && res.result.records ? res.result.records : [];
          this.ipagination.total = res.result.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getQueryParams() {
      let param = Object.assign({});

      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    getQueryField() {
      let str = 'id,';
      this.columns.forEach(function(value) {
        str += ',' + value.dataIndex;
      });
      return str;
    },
    backTap(){
      this.closeCurrent(); 
    }
  },
};
</script>
<style scoped lang="less">
.container {
  height: 100%;
}
.backBtnBox {
  overflow: hidden;
  padding-bottom: 12px;
  button {
    float: right;
  }
}
.memberDetailMain {
  height: calc(100% - 56px);
  .memberDetailLeft {
    width: 20%;
    float: left;
    background: #fff;
    text-align: center;
    padding: 30px 0;
    height: 100%;
    overflow-x: hidden;
    p {
      text-align: left;
      padding-left: 20%;
      padding-right: 30px;
      margin: 0 0 10px;
      line-height: 30px;
      font-size: 18px;
      word-break: break-all;
    }
  }
  .memberDetailRight {
    width: 80%;
    float: right;
    height: 100%;
    overflow-x: hidden;
    .rightMain {
      height: 100%;
      padding-left: 12px;
      .rightBox {
        height: 100%;
        .rightTop {
          background: #fff;
          padding: 30px 0;
          overflow: hidden;
          .topItem {
            padding: 0 70px;
            float: left;
            border-right: 1px solid #ccc;
            &:first-of-type {
              padding-left: 30px;
            }
            &:last-of-type {
              border: none;
              padding-right: 0;
            }
            h3 {
              font-size: 24px;
              margin: 10px 0 0;
              font-weight: bold;
            }
            h4 {
              font-size: 16px;
              margin: 0;
            }
          }
        }
        .rightSub {
          padding: 20px 30px;
          background: #fff;
          margin-top: 12px;
          height: calc(100% - 142px);
          > h3 {
            font-size: 18px;
            margin: 0;
            margin-bottom: 20px;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>